import { CanDeactivateFn } from '@angular/router';
import type { ArticuloFormComponent } from './articulo-form.component';

export const articuloFormCanDeactivate: CanDeactivateFn<ArticuloFormComponent> = (component) => {
  return component.confirmarSalidaSiDatosPendientes();
};
